import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Linkedin, Mail } from "lucide-react";
import PageHero from "../components/common/PageHero";
import { Reveal, SectionHeading } from "../components/common/Section";
import TeamGrid from "../components/common/TeamGrid";
import { Button } from "../components/ui/button";
import { TEAM, COMPANY_VALUES } from "../data/content";

export default function Company() {
  useEffect(() => {
    document.title = "Company | norse3";
  }, []);

  return (
    <div>
      <PageHero
        eyebrow="Company"
        title="An independent control layer for regulated AI."
        subtitle="norse3 exists so regulated firms can see, control and evidence high-risk AI and human interactions — with people accountable for every decision."
      />

      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <SectionHeading
              eyebrow="What we believe"
              title="Independent, accountable, evidence-led."
            />
          </Reveal>
          <Reveal className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" delay={100}>
            {COMPANY_VALUES.map((v) => (
              <div key={v.title} className="rounded-xl border border-white/10 bg-navy-900/60 p-6">
                <h3 className="text-base font-semibold text-foreground">{v.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="border-t border-white/10 py-16 lg:py-20 bg-navy-950/40">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <SectionHeading eyebrow="The team" title="The founders behind norse3." />
          </Reveal>
          <Reveal className="mt-10" delay={100}>
            <TeamGrid variant="detailed" />
          </Reveal>
        </div>
      </section>

      <section className="border-t border-white/10 py-16 lg:py-20">
        <div className="mx-auto max-w-4xl px-5 lg:px-8">
          <div className="rounded-lg border border-white/10 bg-navy-900/60 p-8 lg:p-10 text-center">
            <SectionHeading
              title="Talk to the team."
              subtitle="Book a walkthrough, discuss a Lögberg pilot or send us a note."
              align="center"
              className="!max-w-none"
            />
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="/book-a-demo">Book a walkthrough <ArrowRight className="ml-1.5 h-4 w-4" /></Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-white/15 bg-transparent hover:bg-white/5 text-foreground">
                <a href="mailto:info@norse3.com"><Mail className="mr-1.5 h-4 w-4" /> info@norse3.com</a>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
